export const SPACEBAR_KEYCODE = [0, 32];
export const ENTER_KEYCODE = 13;
export const DOWN_ARROW_KEYCODE = 40;
export const UP_ARROW_KEYCODE = 38;
export const ESCAPE_KEYCODE = 27;
export const DOWNCASE_A_KEYCODE = 65;
export const DOWNCASE_Z_KEYCODE = 99;
export const TAB_KEYCODE = 9;
